/**
 * queue-smart-cells — the "bank truth" cell renderers: how many times an
 * element has been queued, when a restore last revived it, and the tri-state
 * tracker badge (live / deleted-at / never pushed).
 * For Media Devoted | Created By Ciro Autiero
 */

import { ReactNode } from 'react';
import type { QueueElement } from '@trafficpulse/shared';

import { TrackerStateBadge } from '@/components/ui';
import { formatDateTimeGb } from '@/lib/utils';

export function timesQueuedCell(el: QueueElement): ReactNode {
  return (
    <span
      className="whitespace-nowrap tabular-nums"
      title={`Entered the queue ${el.timesQueued} time(s)`}
    >
      ×{el.timesQueued}
    </span>
  );
}

export function lastRestoredCell(el: QueueElement): ReactNode {
  return (
    <span className="whitespace-nowrap tabular-nums text-muted-foreground">
      {el.lastRestoredAt ? formatDateTimeGb(el.lastRestoredAt) : '—'}
    </span>
  );
}

export function trackerTruthCell(el: QueueElement): ReactNode {
  return (
    <TrackerStateBadge
      added={el.addedToTracker}
      removedAt={el.trackerRemovedAt}
      liveLabel="On tracker"
    />
  );
}
